<template>
  <li :class="rootClasses">
    <button
      class="dd-effects__mode-header"
      type="button"
      :disabled="disabled"
      @click="select"
      :aria-pressed="active"
    >
      <span class="dd-effects__mode-radio" aria-hidden="true">
        <span class="dd-effects__mode-radio-dot"></span>
      </span>
      <div class="dd-effects__mode-copy">
        <span class="dd-effects__mode-title">{{ title }}</span>
        <span v-if="subtitle" class="dd-effects__mode-subtitle">{{ subtitle }}</span>
      </div>
      <div v-if="$slots.badge" class="dd-effects__mode-badge">
        <slot name="badge"></slot>
      </div>
    </button>
    <transition name="dd-effects-slide">
      <div v-if="active" class="dd-effects__mode-content">
        <slot></slot>
      </div>
    </transition>
  </li>
</template>
<script>
export default {
  name: 'PaymentModeItem',
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    active() {
      return this.$store.getters.paymentMode === this.id;
    },
    rootClasses() {
      return {
        'dd-effects__mode-item': true,
        'is-active': this.active,
        'is-disabled': this.disabled,
      };
    },
  },
  methods: {
    select() {
      if (this.disabled) {
        return;
      }
      this.$store.dispatch('setPaymentMode', this.id);
    },
  },
};
</script>
